// LikeIconButton.tsx
import * as React from 'react';
import { Box, Tooltip, IconButton, Zoom, CircularProgress, Typography } from '@mui/material';
import FavoriteIcon from '@mui/icons-material/Favorite';
import { useTranslation } from 'react-i18next';
import { SetButtonCallbackFunction } from '../types/callback';

export default function LikeIconButton({ object, likeLoading, likeFunction }: { object: any, likeLoading: boolean, likeFunction: SetButtonCallbackFunction }){
    const { t } = useTranslation();

    return (
        <Box sx={{ position:'fixed', right:'0', top:'calc(48%)', zIndex:'2', maxWidth:'120px' }}>
            <Tooltip title={t("project.like.tooltip")}
                     placement="bottom"
                     slots={{
                        transition: Zoom,
                     }}
                     slotProps={{
                        transition: { timeout: 300 },
                     }} arrow>
                <IconButton color="secondary"
                        size="medium"
                        sx={{
                            height: '48px',
                            width: '120px',
                            alignSelf: 'center',
                            backgroundColor: 'rgb(255, 255, 255)',
                            '&:hover': {
                                color: 'white',
                                backgroundColor: 'rgba(0, 0, 0, 0.75)',
                                borderColor: 'white'
                            },
                            '&:active': {
                                backgroundColor: 'rgba(0, 0, 0, 0.35)',
                                transform: 'scale(0.98)',
                                borderColor: 'white',
                            }
                        }}
                        onClick={() => likeFunction(object)}
                        aria-label="Like" >
                    {likeLoading ? (
                        <Box sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                borderRadius: 1,
                              }}>
                            <CircularProgress size={24} color="inherit" />
                            <Typography sx={{ display: 'inline-block' }}>
                                {object.likes_count + ' ' + t('project.like.button')}
                            </Typography>
                        </Box>
                    ) : (
                        <Box sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                borderRadius: 1,
                             }}>
                            <FavoriteIcon />
                            <Typography sx={{ display: 'inline-block' }}>
                                {object.likes_count + ' ' + t('project.like.button')}
                            </Typography>
                        </Box>
                    )}
                </IconButton>
            </Tooltip>
        </Box>
    );
}
